import React from "react";

const Login = () => {
  return (
    <div>
      <h3 className="mt-5 text-center">
        Please Login(in order to access to contact form)
      </h3>
    </div>
  );
};

export default Login;
